<script>
import {apiUrl} from '../config.svelte';

import {onMount,onDestroy} from 'svelte'; 
import {Input,Table,CustomInput} from 'sveltestrap'
let mailings=[]
let filter_project=""
let filter_name = ""
let filter_date = undefined;

onMount(()=>{
    loadMailings()
})

function loadMailings(){
    mailings=[]
    fetch(apiUrl+"mail",{
        credentials: "include",
        method:"POST",
        cors:'no-cors',
        body:JSON.stringify({method:"get-mailings"})
    })
    .then(x=>x.json())
    .then(x=>{
        if (x.result){
            mailings=x.data
        }
    })
    .catch((e)=>{
        console.log(e)
    })
}
</script>

<Input type="text" placeholder="проект" bind:value={filter_project} style="width:250px;float:left;margin-left:15px"/>
<Input type="text" placeholder="название" bind:value={filter_name} style="width:250px;float:left;margin-left:15px"/>
<CustomInput type="date" on:change={(e)=>{filter_date=e.target.value}} style="width:250px;float:left;margin-left:15px"/>
<Table size="sm" hover>
    <tr>
        <th>Проект</th>
        <th>название рассылки</th>
        <th>дата</th>
        <th>всего</th>
        <th>отправлено</th>
        <th>ошибка отправки</th>
        <th>в очереди</th>
        <th>доставлено</th>
        <th>прочтено</th>
        <th>не доставлено</th>
    </tr>
    {#each mailings as mail}
        {#if (filter_project && mail.project &&mail.project.toLowerCase().indexOf(filter_project)!=-1 || !filter_project)
            &&
            (filter_name && mail.spam_name && mail.spam_name.toLowerCase().indexOf(filter_name)!=-1 || !filter_name)
            &&
            (filter_date && mail.insert_date && mail.insert_date.toString().indexOf(filter_date.toString())!=-1 || !filter_date)
        }
            <tr>
                <td>{mail['project']}</td>
                <td>{mail['spam_name']}</td>
                <td>{mail['insert_date']}</td>
                <td>{mail['всего']}</td>
                <td>{mail['отправлено']}</td>
                <td>{mail['ошибка отправки']}</td>
                <td>{mail['в очереди']}</td>
                <td>{mail['доставлено']}</td>
                <td>{mail['прочтено']}</td>
                <td>{mail['не доставлено']}</td>
            </tr>
        {/if}
    {/each}
</Table>

